// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2BDAT","productName":"Table_productName__3tcqM"};